import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';

import { PlaceholderImgSVG } from './PlaceholderImgSVG';

const useStyles = makeStyles((theme) => ({
  placeholderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  placeholderTxt: {
    marginTop: theme.spacing(4),
  },
}));

export const EmptyContentPlaceholder: React.FC<{ message: string }> = ({
  message,
}) => {
  const styles = useStyles();

  return (
    <View style={styles.placeholderWrapper}>
      <PlaceholderImgSVG />
      <Typography
        variant="primary"
        weight="medium"
        size="md"
        style={styles.placeholderTxt}>
        {message}
      </Typography>
    </View>
  );
};
